<template>
  <section
    class="component-hzl8uip8"
    resmed-component-name="product_manual_list"
  >
    <div class="component">
      <div class="container">
        <div class="categories">
          <p>Select a category to filter:</p>
          <ul>
            <li v-for="category in categories">
              <button
                class="btn btn-dropdown"
                :class="{
                  'is-active':
                    !pendingProductType &&
                    selectedProductType === category.slug,
                  'is-toggled':
                    pendingProductType === category.slug ||
                    (!pendingProductType &&
                      selectedProductType === category.slug),
                }"
                type="button"
                @click="
                  pendingProductType =
                    pendingProductType === category.slug ? null : category.slug
                "
              >
                {{ category.name }}
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div class="filters-container" v-if="pendingProductType">
        <button
          v-if="['xs', 'sm'].includes($root.mode)"
          class="btn btn-dropdown is-toggled"
          type="button"
          @click="pendingProductType = null"
        >
          {{ pendingProductTypeName }}
        </button>

        <div class="container">
          <template v-if="['xs', 'sm'].includes($root.mode)">
            <div class="filter-action-bar">
              <button
                class="btn cta-pill hallow-red"
                type="button"
                @click="applyPendingFilters()"
              >
                Apply Filters&nbsp;&nbsp;&plus;
              </button>
              <button
                class="btn cta-pill cta-plain text-red"
                type="button"
                @click="clearAppliedFilters()"
              >
                Clear All&nbsp;&nbsp;&times;
              </button>
            </div>

            <hr />
          </template>

          <div class="filters">
            <div
              class="series-filter-container"
              v-if="pendingFilters.series.length"
            >
              <p>Product Series</p>
              <ul class="series-filters">
                <li v-for="series in pendingFilters.series.sort()">
                  <a
                    :class="{ 'is-active': pendingProductSeries === series }"
                    href="javascript:void(0)"
                    @click.prevent="
                      pendingProductSeries =
                        pendingProductSeries === series ? null : series
                    "
                    >{{ series }}</a
                  >
                </li>
              </ul>
            </div>
            <div class="models-filter-container">
              <p>Models</p>

              <ul class="model-filters">
                <li v-for="model in pendingFilters.models.sort()">
                  <ui-checkbox
                    :label="model"
                    v-model="pendingProductModels"
                    :name="model"
                    :value="model"
                  ></ui-checkbox>
                </li>
              </ul>
            </div>
          </div>

          <hr />

          <div class="filter-action-bar">
            <button
              class="btn cta-pill hallow-red"
              type="button"
              @click="applyPendingFilters()"
            >
              Apply Filters&nbsp;&nbsp;&plus;
            </button>
            <button
              class="btn cta-pill cta-plain text-red"
              type="button"
              @click="clearAppliedFilters()"
            >
              Clear All&nbsp;&nbsp;&times;
            </button>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="stage">
          <div class="loading" v-if="loading">
            <div class="spinner"></div>
          </div>

          <p class="text-danger" v-if="!loading && error">{{ error }}</p>

          <div v-if="!loading && !error">
            <div class="results">
              <div
                class="applied-filters-container"
                v-if="selectedProductSeries || selectedProductModels.length"
              >
                <p>Applied filters:</p>
                <span
                  class="applied-filter"
                  @click="selectedProductSeries = null"
                  v-if="selectedProductSeries"
                  >{{ selectedProductSeries }}&nbsp;&nbsp;&times;</span
                >
                <span
                  class="applied-filter"
                  v-for="spm in selectedProductModels"
                  @click="
                    selectedProductModels = selectedProductModels.filter(
                      (_spm) => _spm !== spm
                    )
                  "
                  >{{ spm }}&nbsp;&nbsp;&times;</span
                >
                <button
                  class="btn cta-plain text-red"
                  type="button"
                  @click="clearAppliedFilters()"
                >
                  Reset filters
                </button>
              </div>
              <h3>{{ resultDescriptionTitle }}</h3>

              <p>
                {{ $getTranslation("Displaying", $route.params.region) }}: {{ displayingMin }} - {{ displayingMax }} of
                <strong>{{ filteredManuals.length }}</strong> result{{
                  filteredManuals.length === 1 ? $getTranslation("result", $route.params.region) : $getTranslation("results", $route.params.region)
                }}
              </p>
            </div>
            <div class="items">
              <div
                class="item"
                v-for="(manual, mIdx) in filteredManuals.slice(0, maxVisible)"
              >
                <div
                  class="card"
                  :class="manual.product_type"
                  :style="{
                    'border-top-color': productTypeColors[manual.product_type],
                  }"
                >
                  <div class="content">
                    <p class="category-name">{{ manual.product_type_label }}</p>
                    <h3>{{ manual.title }}</h3>
                    <ul>
                      <li v-for="productUse in manual.product_uses">
                        {{ productUse }}
                      </li>
                    </ul>

                    <div class="action-bar" v-if="manual.cta.files.length >= 1">
                      <a
                        v-if="manual.cta.files.length > 1"
                        @click.stop="
                          activeManualId =
                            activeManualId === manual.multisite_id
                              ? null
                              : manual.multisite_id
                        "
                        class="
                          btn
                          show-files-btn
                          cta-plain
                          text-red
                          icon
                          right-arrow
                        "
                        >{{ manual.cta.text }}
                        <div
                          class="tooltip"
                          v-if="activeManualId === manual.multisite_id"
                        >
                          <div class="content">
                            <ul>
                              <li v-for="file in manual.cta.files">
                                <a
                                  class="
                                    btn
                                    cta-plain
                                    text-red
                                    icon
                                    right-arrow
                                  "
                                  @click="trackManualView(manual)"
                                  :href="file.file"
                                  target="_blank"
                                  >{{ file.language }}</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </a>

                      <a
                        v-if="manual.cta.files.length === 1"
                        @click="trackManualView(manual)"
                        :href="manual.cta.files[0].file"
                        target="_blank"
                        class="
                          btn
                          show-files-btn
                          cta-plain
                          text-red
                          icon
                          right-arrow
                        "
                        >{{ manual.cta.text }}</a
                      >

                      <a
                        @click.capture="
                          copyManualLink(
                            manual.cta.files[0].file,
                            $refs.manualShareLinkEl[mIdx]
                          )
                        "
                        :key="manual.multisite_id"
                        ref="manualShareLinkEl"
                        href="javascript:void(0);"
                        class="btn cta-plain text-red"
                      >
                        <img src="@/assets/images/icon-copy-link.svg" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center mt-4" v-if="shouldShowLoadMoreButton">
              <button
                class="btn cta-pill hallow-red"
                type="button"
                @click="loadMoreResults(20)"
              >
                Load More&nbsp;&nbsp;&plus;
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UiCheckbox from "../shared-support/ui-checkbox";
import wpApi from "../../services/wpApi";

export default {
  name: "component-hzl8uip8", // product_manual_list
  props: ["acf"],
  components: { UiCheckbox },
  data() {
    return {
      loading: false,
      error: "",
      categories: [],
      manuals: [],
      productTypeColors: {},

      pendingProductType: null,
      pendingProductSeries: null,
      pendingProductModels: [],

      selectedProductType: null,
      selectedProductSeries: null,
      selectedProductModels: [],

      maxVisible: 20,

      activeManualId: null,
    };
  },
  watch: {
    pendingProductType(v) {
      if (v && v === this.selectedProductType) {
        this.pendingProductSeries = this.selectedProductSeries;
        this.pendingProductModels = [...this.selectedProductModels];
      } else {
        this.pendingProductSeries = null;
        this.pendingProductModels = [];
      }
    },
    pendingProductSeries(n, o) {
      if ((n && !o) || (n && o)) {
        this.pendingProductModels = [];
      }
    },
  },
  created() {
    for (let value of this.acf.categories) {
      this.categories.push({
        slug: value.name.toLowerCase(),
        name: value.name,
      });

      this.productTypeColors = {
        ...this.productTypeColors,
        [value.name.toLowerCase()]: value.color,
      };
    }

    this.loading = true;

    wpApi.getProductManuals({ categories: this.categories.map((c) => c.slug) })
      .then((response) => {
        this.manuals = response.data.manuals;
        bus.$emit(
          "recently-viewed-product-manuals:init",
          this.productTypeColors
        );
      })
      .catch(() => {
        this.error =
          "There was an error loading product manuals, please try again later";
      })
      .then(() => {
        this.loading = false;
      });

    $(document).on("click", (e) => {
      if (!$(e.target).closest(".show-files-btn").length) {
        this.activeManualId = null;
      }
    });
  },
  computed: {
    shouldShowLoadMoreButton() {
      return this.maxVisible < this.filteredManuals.length;
    },
    displayingMin() {
      return this.filteredManuals.length ? 1 : 0;
    },
    displayingMax() {
      return Math.min(this.filteredManuals.length, this.maxVisible);
    },
    filteredManuals() {
      return this.manuals.filter((m) => {
        return (
          (this.selectedProductType
            ? m.product_type === this.selectedProductType
            : true) &&
          (this.selectedProductSeries
            ? m.product_series.includes(this.selectedProductSeries)
            : true) &&
          (this.selectedProductModels.length
            ? m.product_models.filter((pm) =>
                this.selectedProductModels.includes(pm)
              ).length
            : true)
        );
      });
    },
    pendingFilters() {
      const manuals = this.manuals.filter(
        (m) => m.product_type === this.pendingProductType
      );

      return {
        series: Array.from(
          manuals.reduce((all, m) => {
            m.product_series.forEach((ps) => all.add(ps));
            return all;
          }, new Set())
        ),
        models: Array.from(
          manuals.reduce((all, m) => {
            m.product_models.forEach((pm) => {
              if (
                !this.pendingProductSeries ||
                m.product_series.includes(this.pendingProductSeries)
              ) {
                all.add(pm);
              }
            });
            return all;
          }, new Set())
        ),
      };
    },
    resultDescriptionTitle() {
      return `${this.selectedProductSeries || "All product"} manuals`;
    },
    pendingProductTypeName() {
      const pt = this.categories.find(
        (c) => c.slug === this.pendingProductType
      );
      return pt ? pt.name : null;
    },
  },
  methods: {
    copyManualLink(textToCopy, el) {
      this.$copyText(textToCopy)
        .then(() => {
          $(el)
            .addClass("shadow-pulse")
            .on("animationend", () => $(el).removeClass("shadow-pulse"));
        })
        .catch((e) => console.error(e));
    },
    loadMoreResults(numToLoad) {
      this.maxVisible += numToLoad;
    },
    applyPendingFilters() {
      // only apply filters if we selected a series or at least one model
      if (this.pendingProductSeries || this.pendingProductModels.length) {
        this.selectedProductType = this.pendingProductType;
        this.selectedProductSeries = this.pendingProductSeries;
        this.selectedProductModels = [...this.pendingProductModels];
      }

      this.pendingProductType = null;
    },
    clearAppliedFilters() {
      this.selectedProductType = null;
      this.selectedProductSeries = null;
      this.selectedProductModels = [];

      this.pendingProductType = null;
    },
    trackManualView(manual) {
      try {
        let ids = JSON.parse(
          localStorage.getItem("recently-viewed-product-manuals") || "[]"
        );

        if (!ids.includes(manual.multisite_id)) {
          ids = [...ids, manual.multisite_id];
        }

        localStorage.setItem(
          "recently-viewed-product-manuals",
          JSON.stringify(ids)
        );
      } catch (e) {
        console.error("unable to track recently viewed manual", e);
      }

      setTimeout(() => {
        this.activeManualId = null; // closes the dropdown after the click
      }, 0);
    },
  },
};
</script>

<style lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/base/utilities";

// extend style
%component {
  @keyframes shadowPulse {
    0% {
      box-shadow: 0 0 0 4px rgb(0, 170, 14, 0.8);
    }

    100% {
      box-shadow: 0 0 50px 0 rgba(0, 180, 11, 0);
    }
  }

  .shadow-pulse {
    animation-name: shadowPulse;
    animation-duration: 0.6s;
    animation-iteration-count: 1;
    animation-timing-function: linear;
  }

  .categories {
    margin-bottom: 1rem;

    @media (max-width: 767px) {
      padding: 0 2rem;
    }

    p {
      @extend %body-small-bold;
      margin-bottom: 1rem;
    }

    ul {
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      @media (min-width: 768px) {
        justify-content: flex-start;
      }

      li {
        margin: 0 0 0.5rem 0;
        // margin: 0 1.25rem 1.25rem 0;

        @media (min-width: 768px) {
          margin: 0 1.25rem 0 0;
        }

        @media (max-width: 767px) {
          width: 100%;

          .btn-dropdown {
            width: 100%;
          }
        }
      }
    }
  }

  .loading {
    display: flex;
    padding: 2rem;
    justify-content: center;
  }

  .stage {
    padding: 1rem 0;

    .applied-filters-container {
      padding: 1rem 0 2rem 0;

      p {
        @extend %body-small-bold;
        font-size: 12px;
      }

      .applied-filter {
        display: inline-block;
        margin-right: 1rem;
        margin-bottom: 0.75rem;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }

      .cta-plain {
        background: rgba(255, 255, 255, 0);
      }
    }

    .results {
      margin-bottom: 1rem;

      @media (max-width: 767px) {
        padding: 0 2rem;
      }

      h3 {
        margin-bottom: 0.25rem;
      }
    }

    .items {
      .item {
        %border-color {
          border-top: 12px solid transparent;
        }

        .card {
          position: relative;
          width: 100%;

          @extend %border-color;
          background-color: $cc-resmed-white;
          border-radius: 6px;
          box-shadow: -1px 0.25rem 12px 2px rgba(0, 0, 0, 0.125);
          min-height: 302px;
          height: 100%;

          .category-name {
            position: relative;
            margin-bottom: 0.75rem;
            text-transform: capitalize;

            @extend %eyebrow;
            @extend %body-normal-bold;

            &:before {
              top: -0.625rem;
            }
          }
        }

        .content {
          padding: 2rem 1.75rem 2rem 1.75rem;
          display: flex;
          height: 100%;
          flex-direction: column;

          h3 {
            margin-bottom: 1rem;
            min-height: 56px;
          }

          ul {
            list-style: none;
            margin-bottom: 0;
          }

          .action-bar {
            padding-top: 1rem;
            display: flex;
            margin-top: auto;
            width: 100%;
            position: relative;
            justify-content: space-between;
            align-items: center;
          }
        }
      }
    }
  }
}

// this component
.component-hzl8uip8 {
  padding: 3rem 0;
  background-color: #f3f6f8;
  animation: fade-in 2s ease;

  @media (min-width: 992px) {
    min-height: 640px;
  }

  .show-files-btn {
    cursor: pointer;
  }

  .filters-container {
    padding: 2rem;
    background-color: $cc-resmed-grey-15;

    @media (max-width: 767px) {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9999;
      overflow: auto;
      padding: 0;

      .btn-dropdown {
        border-radius: 0;
        width: 100%;
        margin-bottom: 2rem;
      }
    }

    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }

    p {
      position: relative;
      @extend %eyebrow-left;
      @extend %body-small-bold;
      font-size: 0.875rem;
      margin: 2rem 0;
    }

    hr {
      border-color: #979797;
      margin: 2rem 0;
    }

    .filter-action-bar {
      .cta-plain {
        background: rgba(255, 255, 255, 0);
      }
    }

    .filters {
      display: flex;
      flex-direction: row;

      @media (max-width: 991px) {
        flex-direction: column;
      }
    }

    .series-filter-container {
      flex: 1;

      a {
        @extend %body-small-bold;
        color: $cc-resmed-dark-grey;
        display: inline-block;

        background-color: #c8d6e1;
        border-radius: 21px;
        padding: 0.5rem 1.75rem;
        transition: all 0.5s;

        background-repeat: no-repeat;
        background-position: 0.5rem center;

        margin: 0.34375rem 0;
        min-width: 175px;
        text-align: center;

        &.is-active {
          background-color: $cc-resmed-action-red;
          background-image: url(#{$assets}/images/icon-active-button.svg);
          color: $cc-resmed-white;
          padding-right: 1rem;
          padding-left: 2.5rem;
        }
      }

      ul.series-filters {
        @media (max-width: 991px) {
          columns: 2;
        }
      }
    }

    .models-filter-container {
      flex: 3;

      ul {
        columns: 4;

        @media (max-width: 991px) {
          columns: 2;
        }

        li {
          line-height: 2;
        }
      }
    }
  }

  .component {
    @extend %component;

    .stage {
      .items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -0.25rem;

        @media (min-width: 768px) {
          margin: 0 -0.5rem;
        }
      }

      .item {
        width: 50%;
        padding: 0.25rem;

        @media (min-width: 768px) {
          padding: 0.5rem;
          width: 33.33333%;
        }

        @media (min-width: 1200px) {
          width: 25%;
        }
      }
    }
  }

  .tooltip {
    animation: fade-in 0.5s ease;

    z-index: 99;
    position: absolute;
    width: 100%;
    max-width: 200px;

    top: 50px;
    left: 0;

    display: flex;
    flex-direction: column;

    &:after {
      $size: 0.75rem;
      @include caret($size);
      border-bottom: $size solid $cc-resmed-white;

      left: 25%;
      transform: translateX(-50%);
      top: -1.5rem;
    }

    > .content {
      background-color: $cc-resmed-white;
      box-shadow: 0 0 12px 6px rgba(0, 0, 0, 0.125);

      padding: 1rem !important;
      border-radius: 6px;

      text-align: left;

      ul {
        list-style: none;

        li:not(:last-child) {
          margin-bottom: 0.375rem;
          padding-bottom: 0.375rem;
          border-bottom: 1px solid $cc-resmed-bg-grey-1;
        }

        a {
          display: block;
        }

        span {
          @extend %body-small;
          color: $cc-resmed-grey-85;
        }
      }
    }
  }
}

// recently viewed component
.component-sue7nhwz {
  .component {
    @extend %component;

    h2 {
      position: relative;
      margin: 0;
      @extend %eyebrow-center;
    }

    .tooltip {
      .content {
        padding: 0 !important;
      }
    }

    .action-bar {
      align-items: flex-end !important;
    }
  }
}
</style>